import toast from 'react-hot-toast';
import { useEffect, useState } from 'react';
import { toastErrorPydantic } from '../util/toast_pydantic';

import TelaInformativa from './TelaInformativa';

import TituloSessao from '../componentes/TituloSessao';
import DataMesControlled from '../componentes/DataMesControlled';
import IndicadorTabelaHistorico from '../componentes/IndicadorTabelaHistorico';
import BarraBuscaComTodasUnidades from '../componentes/BarraBuscaComTodasUnidades';
import SelectMetricaIndicadorControlled from '../componentes/SelectMetricaIndicadorControlled';

import { servGetIndicadorComHistorico, servPatchIndicador } from '../servicos/servicosEmRotasPrivadas/indicador';
import IndicadorBuscaFiltros from '../componentes/IndicadorBuscaFiltros';

function AjustarIndicadores() {

    console.log('### Iniciando AjustarIndicadores ###');

    const [exibirTelaInformativa, setExibeTelaInformativa] = useState(false)
    const [indicador, setIndicador] = useState(null);
    const [query, setQuery] = useState({
        mesReferencia: null,
        estabelecimento: null,
        metricaCodigo: null
    })

    useEffect(() => {

        const getIndicadorComHistorico = async () => {

            const { estabelecimento, ...resto } = query;
            const queryFinal = { ...resto, estabelecimentoId: estabelecimento?.id };

            try {
                const response = await toast.promise(
                    servGetIndicadorComHistorico(queryFinal),
                    { loading: 'Buscando indicador para edição...' }
                )
                setIndicador(response);
            } catch (error) {
                toastErrorPydantic(error)
                setIndicador(null);
            }
        }

        if (query.mesReferencia && query.estabelecimento && query.metricaCodigo) {
            getIndicadorComHistorico()
        } else {
            if (indicador) setIndicador(null) // Caso o usuário limpe qualquer filtro, deve desconsiderar o indicador
            // Mas, apenas se algum indicador estiver setado, não faz sentido fazer set null em algo que já é null
        }

    }, [query]);

    const patchIndicador = async (e) => {

        e.preventDefault();
        const formData = new FormData(e.target);

        let indicadorReq = {}

        indicadorReq.id = indicador.id
        indicadorReq.numerador = formData.get('numerador');
        indicadorReq.denominador = formData.get('denominador');
        indicadorReq.justificativa = formData.get('justificativa');

        try {
            await toast.promise(
                servPatchIndicador(indicadorReq),
                { loading: 'Enviando informações...' }
            )
            setExibeTelaInformativa(true)
        } catch (error) {
            toastErrorPydantic(error)
            console.error(error);
        }
    }

    function updateFiltro(nome, valor) {
        setQuery(prev => ({
            ...prev,
            [nome]: valor
        }))
    }

    if (exibirTelaInformativa) {
        return <TelaInformativa cabecalho='Indicador ajustado com sucesso'
            mensagem='Clique no botão abaixo para retornar à tela de Ajuste de Indicadores'
            pathRedirect={null}
            buttonMessage='Voltar'
            urlExterna={false} />;
    }

    return (
        <div className='d-flex flex-column container'>
            <TituloSessao titulo='Ajustar indicadores' barraDecorativa={false} centralizaTitulo={true} />
            <div className='div-com-borda p-3'>
                <IndicadorBuscaFiltros
                    // metrica
                    metricaCodigo={query.metricaCodigo}
                    metricaOnChange={
                        (v) => updateFiltro("metricaCodigo", v)
                    }
                    // mes referencia
                    mesReferencia={query.mesReferencia}
                    mesReferenciaOnChange={
                        (v) => updateFiltro("mesReferencia", v)
                    }
                    // estabelecimento
                    estabelecimento={query.estabelecimento}
                    estabelecimentoOnChange={
                        (v) => updateFiltro("estabelecimento", v)
                    }
                />
            </div>
            {
                indicador &&
                <div className=''>
                    <TituloSessao titulo='Novos dados do indicador' barraDecorativa={false} centralizaTitulo={true} />

                    <form className='d-flex flex-column gap-3' onSubmit={patchIndicador}>
                        <div className='d-flex flex-column div-com-borda gap-3 p-3'>
                            <div className='d-flex gap-3'>
                                <div className='col-3'>
                                    <label className='form-label' htmlFor='input-numerador'>Numerador</label>
                                    <input
                                        className='form-control'
                                        id='input-numerador'
                                        name="numerador"
                                        type="number"
                                        step='0.01'
                                    />
                                </div>
                                <div className='col-3'>
                                    <label className='form-label' htmlFor='input-denominador'>Denominador</label>
                                    <input
                                        className='form-control'
                                        id='input-denominador'
                                        name='denominador'
                                        type='number'
                                        step='0.01'
                                    />
                                </div>
                            </div>
                            <div className=''>
                                <label className='form-label' htmlFor='input-justificativa'>Justificativa</label>
                                <textarea
                                    className='form-control'
                                    id='input-justificativa'
                                    type='text'
                                    name='justificativa'
                                />
                            </div>
                        </div>

                        <button
                            className="btn btn-primary"
                            type="submit"
                        > GRAVAR
                        </button>

                    </form>

                    <TituloSessao titulo='Última versão do indicador' barraDecorativa={false} centralizaTitulo={true} />
                    <div className='d-flex flex-column div-com-borda gap-3 p-3'>
                        <IndicadorTabelaHistorico
                            indicador={indicador}
                            exibirJustificativa={false}
                            onlyLatest={true}
                        />
                        <div className="form-control-plaintext">
                            <strong>Justificativa</strong>
                            <br></br>
                            {indicador.justificativa ? indicador.justificativa : "Sem Justificativa"}
                        </div>
                    </div >
                    <TituloSessao titulo='Histórico do indicador' barraDecorativa={false} centralizaTitulo={true} />
                    <div className='d-flex flex-column div-com-borda gap-3 p-3'>
                        <IndicadorTabelaHistorico
                            indicador={indicador}
                            exibirJustificativa={true}
                            onlyLatest={false}
                        />
                    </div>
                </div >
            }
        </div >
    );
}

export default AjustarIndicadores
